import { client } from "helper/apolloConfig";
import { globalVariables } from "helper/globalVariables";
import { backIcon } from "helper/icons";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { updateDogProfileMutation } from "redux/features/superAdminSlice/manageDogsSlice/manageDogsGql";
import { BottomButtons } from "shared/Components/bottomButtons";
import CustomDatePicker from "shared/Components/datepicker";
import Dropdown from "shared/Components/dropdown";
import { PopUpMessages } from "shared/Components/popUpMessages";
import { TextInput } from "shared/Components/textInput";
import { dogProfileResolver } from "validators/UserValidation";
import { breedDropdown } from "container/OnBoarding/RegisterDog/Constants/breeds";
import PageInfo from "shared/Components/pageInfo";

// const breedData = ["Mixed Breed", "Labrador Retriever", "Afghan Hound"];
const titleData = [
  globalVariables.novice,
  globalVariables.advanced,
  globalVariables.excellent,
  globalVariables.premier,
];
const qsData = [globalVariables.yes, globalVariables.no];
const statusData = [
  globalVariables.active,
  globalVariables.retired,
  globalVariables.deceased,
];

export const EditDogProfile = () => {
  const [checkValidation, setCheckValidation] = useState(false);
  const [showBreedMixInput, setShowBreedMixInput] = useState(false);

  const [formData, setFormData] = useState({
    breed: "",
    titleDate: "",
    title: "",
    qs: "",
    status: "",
  });
  const [loading, setLoading] = useState(false);
  const [apiData, setApiData] = useState({
    title: "",
    desc: "",
    type: "pending",
  });
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const formRef = useRef(null);
  const navigate = useNavigate();
  const { auth } = useSelector((state) => state);
  const data = auth?.manageDogsReducer?.dogProfile;
  const modalRef = useRef();

  useEffect(() => {
    if (data) {
      getProfileDetails();
    }
  }, [data]);

  const getProfileDetails = async () => {
    if (data) {
      setValue("dogName", data?.call_name);
      setValue("ownerName", data?.owner_name);
      setValue("breedMix", data?.breed_mix);
      const isMixedBreed = ["Mixed Breed", "Mixed Breed - Designer Dogs", "Other"].includes(data?.breed);
      setShowBreedMixInput(isMixedBreed);
      setFormData({
        ...formData,
        breed: data?.breed,
        titleDate: data?.titleDate,
        title: data?.title,
        qs:
          data?.qs === null
            ? ""
            : data?.qs
            ? globalVariables.yes
            : globalVariables.no,
        status: data?.status,
      });
    }
  };

  const handelSaveChanges = () => {
    setCheckValidation(true);
    handleSubmit(onHandleSubmit)();
  };
  const handleCancel = () => {
    navigate(-1);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: dogProfileResolver,
    defaultValues: {
      dogName: "",
      ownerName: "",
      breedMix: "",
    },
  });

  const onHandleSubmit = async (credentials) => {
    if (formData.breed) {
      setLoading(true);

      const payload = {
        call_name: credentials.dogName,
        breed: formData.breed,
        registration_name: credentials.ownerName,
      };

      if (showBreedMixInput) {
        payload.breed_mix = credentials.breedMix;
      }

      try {
        const result = await client.mutate({
          mutation: updateDogProfileMutation,
          variables: { id: data?.id, data: payload },
        });

        if (result?.data?.updateRegisteredDog) {
          modalRef.current.openModal();
          setApiData({
            ...apiData,
            title: globalVariables.success,
            desc: result?.data?.updateRegisteredDog?.message,
            type: "success",
          });
        }
        setLoading(false);
      } catch (error) {
        modalRef.current.openModal();
        setApiData({
          ...apiData,
          title: globalVariables.error,
          desc: error?.message,
          type: "pending",
        });
        setLoading(false);
      }
    }
  };

  const handleFormData = (key, value) => {
    setFormData({ ...formData, [key]: value });
  };

  const onCloseModal = () => {
    navigate(-1);
  };

  return (
    <div className="App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10">
      <PageInfo title={globalVariables.editDogProfile} onClick={() => navigate(-1)}/>
        <div className="flex flex-col items-center">
          <span className="font-semibold text-xl text-gray-900">
            {globalVariables.dogDetails}
          </span>
          <div className="mt-6" />
          <form
            className="lg:w-full items-center flex flex-col max-[400px]:w-[90%]"
            onSubmit={handleSubmit(onHandleSubmit)}
            ref={formRef}
          >
            <div className="max-[400px]:w-[90%]">
              <TextInput
                register={register}
                name="dogName"
                placeholder={globalVariables.dogName}
                label={globalVariables.dogName}
                errorMsg={errors.dogName?.message}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
              />
              <div className="mt-5" />
              <Dropdown
                dropdownOptions={breedDropdown}
                placeholder={globalVariables.breed}
                checkValidation={checkValidation}
                label={globalVariables.breed}
                onChange={(value) => {
                  handleFormData("breed", value);
                  const isMixedBreed = ["Mixed Breed", "Mixed Breed - Designer Dogs", "Other"].includes(value);
                  setShowBreedMixInput(isMixedBreed);
                }}
                defaultOption={formData.breed}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                errorMsg={
                  !formData.breed && checkValidation
                    ? globalVariables.breedError
                    : ""
                }
              />
              {showBreedMixInput && <div className="mt-5" />}
              {showBreedMixInput && (
                <TextInput
                  register={register}
                  name="breedMix"
                  placeholder={globalVariables.specifyBreed}
                  label={globalVariables.breedMix}
                  errorMsg={errors.breedMix?.message}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                />
              )}
              {/* <div className="mt-5" />
              <TextInput
                register={register}
                name="ownerName"
                placeholder={globalVariables.ownerName}
                label={globalVariables.ownerName}
                errorMsg={errors.ownerName?.message}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
              /> */}
              {/* <div className="mt-5" />
              <CustomDatePicker
                label={globalVariables.titleDate}
                onSetDate={(value) => handleFormData("titleDate", value)}
                checkValidation={checkValidation}
                defaultDate={
                  formData.titleDate ? new Date(formData.titleDate) : ""
                }
                placeholder={globalVariables.titleDate}
                minDate={new Date()}
                errorMsg={
                  !formData.titleDate && checkValidation
                    ? globalVariables.titleDateErrr
                    : ""
                }
              />
              <div className="mt-5" />
              <Dropdown
                dropdownOptions={titleData}
                placeholder={globalVariables.title}
                checkValidation={checkValidation}
                label={globalVariables.title}
                onChange={(value) => handleFormData("title", value)}
                defaultOption={formData.title}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                errorMsg={
                  !formData.title && checkValidation
                    ? globalVariables.titleError
                    : ""
                }
              />
              <div className="mt-5" />
              <Dropdown
                dropdownOptions={qsData}
                placeholder={globalVariables.qs}
                checkValidation={checkValidation}
                label={globalVariables.qs}
                onChange={(value) => handleFormData("qs", value)}
                defaultOption={formData.qs}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                dynamicHeight={"w-[80px]"}
                errorMsg={
                  !formData.qs && checkValidation ? globalVariables.qsError : ""
                }
              /> */}
              <div className="mt-5" />
              {/* <Dropdown
                dropdownOptions={dogLegsData}
                placeholder={globalVariables.dogLegs}
                checkValidation={checkValidation}
                label={globalVariables.dogLegs}
                onChange={(value) => handleFormData("dogLegs", value)}
                defaultOption={formData.dogLegs}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                errorMsg={
                  !formData.dogLegs && checkValidation
                    ? globalVariables.dogLegsError
                    : ""
                }
              /> */}
              {/* <div className="mt-5" />
              <Dropdown
                dropdownOptions={statusData}
                placeholder={globalVariables.status}
                checkValidation={checkValidation}
                label={globalVariables.status}
                onChange={(value) => handleFormData("status", value)}
                defaultOption={formData.status}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                errorMsg={
                  !formData.status && checkValidation
                    ? globalVariables.statusError
                    : ""
                }
              /> */}
            </div>
            <div className="flex flex-row justify-between">
              {!isMobile && (
                <div>
                  <BottomButtons
                    outlineLabel={"Cancel Changes"}
                    fullLabel={"Save Changes"}
                    disabled={loading}
                    onTapYes={handelSaveChanges}
                    onTapNo={handleCancel}
                    position={"sticky"}
                    extraClass={"border-transparent"}
                    isBgTransparent
                    btnCustomWidth="w-40 lg:w-44 max-[400px]:w-[140px] max-[280px]:w-[130px]"
                  />
                </div>
              )}
            </div>
          </form>
        </div>
      {isMobile && (
        <BottomButtons
          outlineLabel={globalVariables.cancelChanges}
          fullLabel={globalVariables.saveChanges}
          onTapYes={handelSaveChanges}
          onTapNo={handleCancel}
          position="fixed"
          btnCustomWidth="w-40 lg:w-44 max-[400px]:w-[140px] max-[280px]:w-[130px]"
        />
      )}
      <PopUpMessages
        title={apiData.title}
        desc={apiData.desc}
        type={apiData.type}
        ref={modalRef}
        onCloseModal={onCloseModal}
      />
    </div>
  );
};
